const Logo = ({ className = '', ...props }) => (
  <img src="/Frame 566 (2).png" alt="Mendable logo" className={className + " w-10 h-10 rounded-lg border border-gray-700/75"} />
);

export default Logo;
